export interface MobileConeUnitInfoDataInterface {
  [modelName: string]: MobileConeDataInterface;
}
export interface MobileConeDataInterface {
  configurations: {
    type: string;
    displayName: string;
    displayOrder: number;
    configurationOptions: { configKey: number; displayName: string }[];
    CONE1: {
      model: { displayName: string; simulationModel: string };
      defaultConcave: string;
      defaultMantle: string;
      defaultThrow: number;
      defaultCss: number;
    };
    SCREEN1: {
      model: { displayName: string };
      sepSizes: number[];
      decks: {
        0: {
          defaultSeparationSize: number;
          minRecommendedSeparationSize: number;
          maxRecommendedSeparationSize: number;
        };
        1: {
          defaultSeparationSize: number;
          minRecommendedSeparationSize: number;
          maxRecommendedSeparationSize: number;
        };
      };
      minRecommendedSeparationSize: number;
      maxRecommendedSeparationSize: number;
      defaultSeparationSize0: number;
      defaultSeparationSize1: number;
      defaultSeparationSize2: number;
      defaultSepSize: number;
    };
    SCREEN2: {
      model: { displayName: string };
      defaultSeparationSize0: number;
      defaultSeparationSize1: number;
    };
    CONVENTIONAL_SCREEN1: {
      model: { displayName: string; simulationModel: string };
      defaultRockMaterialName: string;
      defaultRockMaterialValue: string;
      defaultInclination: number;
      defaultOverUnderSizeDeck1Name: string;
      defaultOverUnderSizeDeck1Value: string;
      defaultOverUnderSizeDeck2Name: string;
      defaultOverUnderSizeDeck2Value: string;
      defaultOverUnderSizeDeck3Name: string;
      defaultOverUnderSizeDeck3Value: string;
      defaultMediaDeck1Name: string;
      defaultMediaDeck1Value: string;
      defaultMediaDeck2Name: string;
      defaultMediaDeck2Value: string;
      defaultMediaDeck3Name: string;
      defaultMediaDeck3Value: string;
      defaultSeparationSize0: number;
      defaultSeparationSize1: number;
      defaultSeparationSize2: number;
      defaultSeparationSize3: number;
      rockMaterials: { name: string; value: string }[];
      inclination: number[] | null;
      overUnderSize: { name: string; value: string }[] | null;
      maxRecommendedSeparationSize: number;
      minRecommendedSeparationSize: number;
    };
    FREEFALL_SCREEN1: {
      models: { displayName: string; simulationModel: string }[];
      minRecommendedSeparationSize: number;
      maxRecommendedSeparationSize: number;
      defaultSeparationSize0: number;
      defaultSeparationSize1: number;
      defaultSeparationSize2: number;
    };
    PAN_FEEDER1: { model: { displayName: string; simulationModel: string } };
    FREEFALL_SCREEN_SF1: {
      model: { displayName: string };
      minRecommendedSeparationSize: number;
      maxRecommendedSeparationSize: number;
      defaultSeparationSize0: number;
      defaultSeparationSize1: number;
      defaultSeparationSize2: number;
    };
    SPLIT1: {
      defaultAmountRight: number;
      amountRightOptions: number[];
    };
  };
  deckDetails: {
    [deckNbr: string]: {
      STEEL_PLATE: {
        minHole: number;
        maxHole: number;
        maxFeedSize: number;
        displayName: string;
      };
      WIRE_SQUARE: {
        minHole: number;
        maxHole: number;
        maxFeedSize: number;
        displayName: string;
      };
      WIRE_SLOTTED_MOBILE: {
        minHole: number;
        maxHole: number;
        maxFeedSize: number;
        displayName: string;
      };
      WIRE_HARP: {
        minHole: number;
        maxHole: number;
        maxFeedSize: number;
        displayName: string;
      };
    };
  };
}

/**
 * Enum for all available models of a Mobile Cone Unit
 */
export enum MobileUnitConeCrusherTypes {
  QH332 = 'QH332',
  QS332 = 'QS332',
  QH441 = 'QH441',
  QH443E = 'QH443E',
  UH311 = 'UH311',
  UH312 = 'UH312',
  UH412 = 'UH412',
  UH316 = 'UH316',
  US440E = 'US440E',
  UH440i = 'UH440i',
  US440i = 'US440i',
  UH320_Flex = 'UH320_Flex',
  UH440E = 'UH440E',
  UH640 = 'UH640',
  US316 = 'US316',
  UK373 = 'UK373',
  UH373 = 'UH373',
  UH573 = 'UH573',
  US373 = 'US373',
  US640E = 'US640E',
}
